// 立陶宛语言
export default {
  home: {
    minute: 'minutę',
    price_info: 'Nemokamai pirmas {mianfei} min. Maksimalus dienos mokestis {currencyName}{fengding}. Užstatas bus automatiškai nuskaičiuotas, kai nuoma pasieks {currencyName}{yajin}',
    feature_1: 'Pritaikyta visų rūšių mobiliesiems telefonams',
    feature_2: 'Galima grąžinti į bet kurią kitą vietą',
    feature_3: 'Specialus dizainas – belaidis įkrovimas(tik palaikomiems moduliams)',
    tips_1: 'Jūsų {currencyName}{yajin} užstatas bus grąžintas Jums, kai grąžinsite nešiojamą įkroviklį.',
    tips_2: 'Papildymo mokestis {currencyName}{yajin} galima išnuomoti, sunaudotas gali būti grąžintas',
    tips_3: 'Dabartinis likutis yra {currencyName}{myyue}, kurį galima tiesiogiai išnuomoti',
    submit: 'Įkrauti',
    borrow: 'Pasiskolinti',
    msg_fail_title: 'Klaida',
    msg_fail_content: 'Nuoma nepavyko, bandykite dar kartą',
    msg_rentcount: 'Šiuo metu turite {zujieNum} neuždarytų užsakymų',
    goborrow: 'Eikite įkrauti!!!',
    nearby: 'Peržiūrėti netoliese esančias prekybos vietas',
    preauth: 'Išankstinis autorizavimas',
    msg_fail_login: 'Įjungimas nepavyko',
    scanqrpls: 'Prašome pirmiausia nuskaityti prietaiso QR kodą'
  },
  login: {
    code_title: 'Patvirtinimas SMS žinute',
    phone_number: 'Telefono numeris',
    verification_code: 'Įveskite SMS patvirtinimo kodą,Jei tikrinimo kodo nėra, pabandykite kitą loginio metodą',
    captcha_code: 'Kodas',
    send_code: 'Siųsti kodą',
    login: 'Prisijungti',
    agree: 'Spustelėdami Prisijungti, sutinkate su ',
    readme: `Vartotojo Sutartis`,
    msg_fail_login: 'Prisijungimas nepavyko',
    msg_success_login: 'Sėkmingas prisijungimas',
    msg_fail_user: 'Klaida gaunant vartotojo informaciją. Ar norite bandyti dar kartą?',
    sign_in_with: 'Prisijungti su',
    no_sms: 'Negavau teksto žinutės',
    retry: 'Siųsti iš naujo'
  },
  confirm: {
    title: 'Mokėjimo patvirtinimas',
    SMSConfirm: 'Prašome mokėti pagal telefonu gautą teksto pranešimą ir paspauskite patvirtinimo mygtuką, kad tęstųsi.',
    pay_label: 'Suma',
    auth_label: 'Išankstinė autorizacija',
    price_tips: 'Jei pageidaujate, Jūsų likutis gali būti atšauktas. Per 1-5 darbo dienas bus grąžintas į mokėtojo sąskaitą.',
    auth_tips: 'Išansktinės autorizacijos suma {0}{1} yra privaloma. Faktinio nuomos mokesčio suma bus atskaičiuota grąžinus nešiojamą įkroviklį.',
    pay_type: 'Pasirinkite pageidaujamą mokėjimo būdą',
    submit: 'Patvirtinkite mokėjimą',
    msg_loading: 'Loading...',
    msg_fail_title: 'Įspėjimas',
    msg_fail_payment: 'Nepavyko inicijuoti įmokos mokėjimo',
    msg_fail_order: 'Nepavyko sukurti nuomos užsakymo',
    msg_fail_support: 'Sistema nepalaikoma',
    msg_fail_confirm: 'Patvirtinti',
    msg_fail_retry: 'Bandykite dar kartą',
    msg_fail_cancel: 'Atšaukti'
  },
  mine: {
    title: 'Vartotojo profilis',
    wallet: 'Mano piniginė',
    balance: 'Mano likutis',
    deposit: 'Įmoka',
    wallet_in: 'Krauti',
    wallet_out: 'Atšaukti',
    wallet_log: 'Piniginės ataskaita',
    order: 'Užsakymas',
    coupon: 'Kuponas',
    login_tips: 'Prašome prisijungti',
    msg_fail_title: 'Klaida',
    msg_fail_update: 'Modifikacija nepavyko, bandykite dar kartą',
    msg_loading: 'Loading...',
    msg_fail_user: 'Klaida gaunant vartotojo informaciją. Ar norite pabandyti dar kartą?',
    help: 'Pagalba',
    setting: 'Nustatymas',
    logout: 'Atsijungti',
    buy: 'Pirkti įrangą'
  },
  msg: {
    msg_fail_phone: 'Įveskite savo telefono numerį',
    no_phone: 'Telefono numeris reikalingas',
    loading: 'Loading...',
    title: 'Hint',
    success: 'Sėkminga operacija',
    error: 'Nežinoma klaida, bandykite dar kartą vėliau.',
    confirm: 'Patvirtinti',
    retry: 'Bandykite dar kartą',
    cancel: 'Atšaukti',
    title_fail: 'Įspėjimas',
    vieworder: 'Peržiūrėti užsakymą',
    success_payment: 'Mokėjimas atliktas',
    success_buy: 'Pirkimas atliktas',
    fail_payment: 'Atsiskaitymas nepavyko',
    keyword: 'raktažodis',
    nodata: 'Duomenų nėra',
    copysuccess: 'Sėkmingai kopijuota'
  },
  result: {
    title: 'Rezultato patvirtinimas',
    price_plan: 'Įkrovimo standartas',
    msg_success: 'Sėkmingai išnuomota',
    msg_tips_loading: 'Nešiojamas įkrovėjas netrukus pasirodys, prašome palaukti...',
    msg_result_loading: 'Mokėjimo rezultatas tvirtinamas...',
    msg_fail_confirm: 'Patvirtinti',
    btn_usage: 'Usage note',
    btn_return: 'Grąžinimo raštelis',
    deposit: 'Įmoka',
    msg_fail_content: 'Užklausa nepavyko, bandykite dar kartą',
    price_label: 'per valandą',
    price_info: 'Pirmas {mianfei} min. nemokamaiļ¼Maksimalus dienos mokestis {ccurrency}{fengding}ļ¼Užstatas bus automatiškai atskaitytas, kai nuoma pasieks {ccurrency}{yajin}',
    tips_1: 'Prašome paimti nešiojamą įkroviklį <span class="number">No.{number}</span> kaip parodytas paveikslėlyje',
    tips_2: 'Sutvarkykite laidus ir norėdami grąžinti įkiškite nešiojamą įkroviklį į apačią  <span class="highlight">[rodyklė žemyn]</span> ',
    msg_note_usage: 'Nešiojamas įkroviklis turi 3 tipų laidus ir belaidį įkrovimą, naudokite pagal poreikį.',
    msg_note_return: 'Prašome sutvarkyti šiuos laidus ir norėdami grąžinti įkiškite nešiojamą įkroviklį į apačią [rodyklė žemyn].',
    return_info: 'Grąžindami, gerai sutvarkykite laidus ir įkiškite šoną su metalinėmis plokštelėmis į tuščią lizdą kol jis pasieks dugną ir stabilizuosis.'
  },
  result_msg: {
    loading: 'Kraunasi...',
    refresh: 'Atnaujinti'
  },
  order: {
    title: 'Nuomos užsakymas',
    in_use: 'Vartojamas',
    ended: 'Baigta',
    msg_error: 'Užklausa nepavyko'
  },
  order_item: {
    order_number: 'Nr.',
    venue_rented: 'Nuomos vieta',
    time_rented: 'Nuomos laikas',
    venue_returned: 'Grąžinimo vieta',
    time_returned: 'Grąžinimo laikas',
    charge_standard: 'Įkrovimo standartas',
    charge_standard_info: '{pJifei} {pCurrency} už valandą(first {pMian} mins for free)',
    rent_occurred: 'Nuoma įvyko',
    returned: 'Sugrąžinta',
    unreturned: 'Nesugrąžinta',
    type_0: 'Nebaigta',
    type_1: 'Išnuomota',
    type_2: 'Atšaukta',
    type_3: 'Grąžinta',
    type_4: 'Įvyko gedimas',
    type_5: 'Viršvalandžiai',
    min: 'Min.',
    payment: 'Mokėjimas'
  },
  setting: {
    title: 'Nustatymas',
    lang: 'Kalba'
  },
  help: {
    title: 'D.U.K.'
  },
  wallet_in: {
    title: 'Mokėjimo papildymas',
    price_label: 'Papildymo suma',
    price_placeholder: 'Įveskite papildymo sumą',
    balance: 'Einamasis likutis',
    price_auto: 'Pasirinkite mokėjimo sumą',
    price_tips: 'Jei pageidaujate, Jūsų likutis gali būti grąžintas. Per 1-5 darbo dienas bus grąžintas į mokėtojo sąskaitą.',
    submit: 'Pateikti',
    loading: 'Kraunasi...',
    paying: 'Pereiti į mokėjimo puslapį...',
    msg_title: 'Arbatpinigiai',
    msg_fail_order: 'Nepavyko sukurti papildymo užsakymo',
    msg_fail_payment: 'Nepavyko inicijuoti papildymo mokėjimo',
    msg_fail_retry: 'Bandykite dar kartą'
  },
  wallet_out: {
    title: 'Atšaukti',
    price_label: 'Išimti sumą',
    price_placeholder: 'Įveskite norimą išimti sumą',
    balance: 'Einamasis likutis',
    balance_all: 'Išimti visą',
    deposit: 'Įmoka',
    deposit_tips: 'Yra nuomos užsakymas. {pcurrencyName}{pyajin} užstatas negrąžinamas',
    submit: 'Pateikti',
    apply: 'Taikyti',
    confirm: 'Patvirtinti',
    loading: 'Kraunasi...',
    msg_fail_price: 'Neteisinga išėmimo suma',
    msg_fail_balance: 'Grąžinimo suma negali būti didesnė už esamą likutį',
    msg_fail_submit: 'Prašome užpildyti visą informaciją',
    msg_title: 'Klaida',
    msg_success_content: 'Grąžinimas sėkmingas',
    confirmtitle: 'Patarimai',
    confirmcontent: 'Dabartinė piniginė nepalaiko grynųjų pinigų išėmimo. Užpildykite savo asmeninę informaciją and refund manually',
    payee_name: 'Gavėjo vardas',
    payee_bankcard: 'Banko kortelės numeris',
    payee_phone: 'Telefono numeris',
    cancelText: 'atšaukti',
    confirmText: 'Kreiptis pakartotinai'
  },
  map: {
    title: 'Šalia įrangos',
    result_msg: 'Netoliese įrangos nerasta',
    msg_title: 'klaida',
    no_support: 'atsiprašome! Jūsų naršyklė nepalaiko vietos nustatymo',
    my_position: 'mano vieta',
    distance: 'atstumas:',
    shop_time: 'valandos',
    free: 'paskolinama',
    return: 'grąžinama',
    shop_title: 'Prekybininko informacija',
    address: 'adresas',
    go_here: 'Eikite čia'
  }
}
